import {isProduction, METRICS} from '../../common/configs';

let Raven;

const reportError = e => {
  if (METRICS) {
    Raven.captureException(e);
  }
};

/* eslint-disable global-require, import/no-dynamic-require */
if (METRICS) {
  Raven = require('raven-js');
  const ravenClientConfig = {
    url: 'https://898fc7b5063741ee8869740e3ac2945f@sentry.xsolla.com/15',
    options: {
      environment: process.env.NODE_ENV,
      release: process.env.BUILD_ID
    }
  };
  Raven.config(isProduction && ravenClientConfig.url, ravenClientConfig.options).install();
}

export {reportError};



// WEBPACK FOOTER //
// ./utils/error-reporter.js